angular.module('quickRegistrationModule', ['quickRegistrationTemplates']);
